const STORAGE_KEY = 'itunu.casesListState';
const ITEMS_STORAGE_KEY = 'itunu.casesListItems';

export type CasesListState = {
  page: number;
  tab: string;
  filter: string;
  pageSize: number;
  search: string;
};

export const DEFAULT_CASES_LIST_STATE: CasesListState = {
  page: 0,
  tab: 'timeline',
  filter: 'all',
  pageSize: 12,
  search: ''
};

export const saveCasesListState = (state: Partial<CasesListState>): void => {
  try {
    const current = loadCasesListState();
    const next: CasesListState = {
      page: typeof state.page === 'number' ? state.page : current.page,
      tab: state.tab || current.tab,
      filter: state.filter || current.filter,
      pageSize:
        typeof state.pageSize === 'number' ? state.pageSize : current.pageSize,
      search: typeof state.search === 'string' ? state.search : current.search
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage failures (private mode / quota).
  }
};

export const loadCasesListState = (): CasesListState => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_CASES_LIST_STATE };
    }
    const parsed = JSON.parse(raw);
    return {
      page: typeof parsed.page === 'number' ? parsed.page : 0,
      tab: typeof parsed.tab === 'string' ? parsed.tab : 'timeline',
      filter: typeof parsed.filter === 'string' ? parsed.filter : 'all',
      pageSize: typeof parsed.pageSize === 'number' ? parsed.pageSize : 12,
      search: typeof parsed.search === 'string' ? parsed.search : ''
    };
  } catch {
    return { ...DEFAULT_CASES_LIST_STATE };
  }
};

export const resolveCasesListState = (locationState?: any): CasesListState => {
  const saved = loadCasesListState();
  return {
    page:
      typeof locationState?.page === 'number'
        ? locationState.page
        : saved.page,
    tab: locationState?.tab || saved.tab,
    filter: locationState?.filter || saved.filter,
    pageSize:
      typeof locationState?.pageSize === 'number'
        ? locationState.pageSize
        : saved.pageSize,
    search:
      typeof locationState?.search === 'string'
        ? locationState.search
        : saved.search
  };
};

export const saveCasesListItems = (items: any[]): void => {
  try {
    const compact = (items || []).map((item) => ({
      _id: item?._id
    }));
    sessionStorage.setItem(ITEMS_STORAGE_KEY, JSON.stringify(compact));
  } catch {
    // Ignore storage failures.
  }
};

export const loadCasesListItems = (): any[] => {
  try {
    const raw = sessionStorage.getItem(ITEMS_STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};
